import type { FC } from 'react'
import styled from '@emotion/styled'

import { CompliantIcon } from '@segment/matcha/components/Icons/Brandbook'
import Typography from '@segment/matcha/components/Typography'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const HEADING = `Customer engagement built on trust`

const CustomerEngagement: FC = () => (
  <StyledSectionBase variant="centered">
    <Section.Copy>
      <CompliantIcon size="large" />
      <Typography variant="h2">{HEADING}</Typography>
    </Section.Copy>
  </StyledSectionBase>
)

export default CustomerEngagement

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`
